import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';
import * as _ from 'lodash';


@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit, OnDestroy {

  @ViewChild('datePickerInput', {static: true}) datePickerInput: any;
  durationSelectedOption: any;
  @Input() from: any;
  @Input() to: any;
  public today = moment();
  public yesterday = moment(this.today).subtract(1, 'days');
  public oneWeek = moment(this.today).subtract(7, 'days');
  public twoWeeks = moment(this.today).subtract(14, 'days');
  public month = moment(this.today).subtract(30, 'days');


  datePickerComponent:any;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  params: any;
  toggleValue = [
    {
      label: '',
      value: 'ALL'
    }
  ];
  datePickerOptions: Partial<BsDatepickerConfig> = {
    showWeekNumbers: false,
    adaptivePosition: true,
    containerClass: 'DatePicker',
    selectFromOtherMonth: true
  };
  durationOptions: Array<{ value: string; labelKey: string }> = [
    { value: 'all', labelKey: 'store.datePicker.all' },
    { value: 'today', labelKey: 'store.datePicker.today' },
    { value: 'yesterday', labelKey: 'store.datePicker.yesterday' },
    { value: 'last_7_days', labelKey: 'store.datePicker.last7' },
    { value: 'last_2_weeks', labelKey: 'store.datePicker.last14' },
    { value: 'last_month', labelKey: 'store.datePicker.last30' },
    { value: 'custom', labelKey: 'store.datePicker.custom' }
  ];
  private langSub?: Subscription;
  isDurationVisible: boolean = false;
  isDatePickerVisible: boolean = false;
  dateFrom: any;
  dateTo: any;
  date = [new Date(), new Date()];
  selectedValue:any;
  selectedValuetobeEmited: any;
  bsInlineValue = new Date();
  bsInlineRangeValue: any;
  maxDate = new Date();

  constructor(private translate: TranslateService) {
  }

  ngOnInit() {
    this.fillSelectedRange();
    this.langSub = this.translate.onLangChange.subscribe(() => this.fillSelectedRange());
  }

  ngOnDestroy() {
    this.langSub?.unsubscribe();
  }

  public fillSelectedRange() {
    if (this.from && this.to) {
      this.toggleValue[0].label = this.from === this.to ? this.from : `${this.from} - ${this.to}`;
    } else {
      this.toggleValue[0].label = this.translate.instant('store.datePicker.selectDate');
    }
    if (!this.from || !this.to) {
      this.durationSelectedOption = this.durationOptions[0].value;
      return;
    } else if (_.isEqual(this.today.format('DD-MM-YYYY').toString(), this.to)
      && _.isEqual(this.today.format('DD-MM-YYYY').toString(), this.from)) {
      this.durationSelectedOption = this.durationOptions[1].value;
    } else if (_.isEqual(this.yesterday.format('DD-MM-YYYY').toString(), this.to)
      && _.isEqual(this.yesterday.format('DD-MM-YYYY').toString(), this.from)) {
      this.durationSelectedOption = this.durationOptions[2].value;
    } else if (_.isEqual(this.oneWeek.format('DD-MM-YYYY').toString(), this.from)
      && _.isEqual(this.today.format('DD-MM-YYYY').toString(), this.to)) {
      this.durationSelectedOption = this.durationOptions[3].value;
    } else if (_.isEqual(this.twoWeeks.format('DD-MM-YYYY').toString(), this.from)
      && _.isEqual(this.today.format('DD-MM-YYYY').toString(), this.to)) {
      this.durationSelectedOption = this.durationOptions[4].value;
    } else if (_.isEqual(this.month.format('DD-MM-YYYY').toString(), this.from)
      && _.isEqual(this.today.format('DD-MM-YYYY').toString(), this.to)) {
      this.durationSelectedOption = this.durationOptions[5].value;
    } else {
      this.durationSelectedOption = this.durationOptions[6].value;
      this.isDatePickerVisible = true;
      this.dateFrom = this.from;
      this.dateTo = this.to;
      const fDate = moment(this.from).format('DD-MM-YYYY');
      const tDate = moment(this.to).format('DD-MM-YYYY');
      this.bsInlineRangeValue = [moment(fDate).toDate(), moment(tDate).toDate()];
    }
  }

  public openDatePickerModel() {
    this.isDurationVisible = !this.isDurationVisible;
    this.selectedValuetobeEmited = 'all';
    this.fillSelectedRange();

  }

  onDurationChange(duration: any) {
    if (typeof duration !== 'string') {
      return;
    }


    let selectedValueMoment;
    if (duration === this.durationOptions[0].value) {
      this.selectedValuetobeEmited = 'all';
      selectedValueMoment = 'All';
      this.isDatePickerVisible = false;
      this.selectedValue = this.translate.instant('store.datePicker.selectDate');

    }
    if (duration === this.durationOptions[1].value) {
      this.isDatePickerVisible = false;
      selectedValueMoment = moment(this.today).format('MMMM Do YYYY');
      this.selectedValuetobeEmited = moment(this.today).format('DD-MM-YYYY');

      this.setSelectedValue(selectedValueMoment);
    } else if (duration === this.durationOptions[2].value) {
      selectedValueMoment = moment(this.yesterday).format('MMMM Do YYYY');
      this.selectedValuetobeEmited = moment(this.yesterday).format('DD-MM-YYYY');
      this.setSelectedValue(selectedValueMoment);
      this.isDatePickerVisible = false;
    } else if (duration === this.durationOptions[3].value) {
      this.isDatePickerVisible = false;
      selectedValueMoment = `${moment(this.oneWeek).format('MMMM Do YYYY')} - ${moment(this.today).format('MMMM Do YYYY')}`;
      this.selectedValuetobeEmited = `${moment(this.oneWeek).format('DD-MM-YYYY')}|${moment(this.today).format('DD-MM-YYYY')}`;
      this.setSelectedValue(selectedValueMoment);
    } else if (duration === this.durationOptions[4].value) {
      this.isDatePickerVisible = false;
      selectedValueMoment = `${moment(this.twoWeeks).format('MMMM Do YYYY')} - ${moment(this.today).format('MMMM Do YYYY')}`;
      this.selectedValuetobeEmited = `${moment(this.twoWeeks).format('DD-MM-YYYY')}|${moment(this.today).format('DD-MM-YYYY')}`;
      this.setSelectedValue(selectedValueMoment);
    } else if (duration === this.durationOptions[5].value) {
      this.isDatePickerVisible = false;
      selectedValueMoment = `${moment(this.month).format('MMMM Do YYYY')} - ${moment(this.today).format('MMMM Do YYYY')}`;
      this.selectedValuetobeEmited = `${moment(this.month).format('DD-MM-YYYY')}|${moment(this.today).format('DD-MM-YYYY')}`;
      this.setSelectedValue(selectedValueMoment);
    } else if (duration === this.durationOptions[6].value) {
      this.isDatePickerVisible = true;
    }
  }

  onDatePickerChange(event: any) {
    this.dateFrom = moment(event[0]).format('DD-MM-YYYY');
    this.dateTo = moment(event[1]).format('DD-MM-YYYY');
    const selectedValueMoment = `${moment(event[0]).format('MMMM Do YYYY')} - ${moment(event[1]).format('MMMM Do YYYY')}`;
    this.selectedValuetobeEmited = `${moment(event[0]).format('DD-MM-YYYY')}|${moment(event[1]).format('DD-MM-YYYY')}`;
    this.setSelectedValue(selectedValueMoment);

    // setTimeout(() => {
    //   let ele = document.getElementById("to") as HTMLElement
    //   if (ele) {
    //     ele.click();
    //   }
    // }, 10);

  }

  onCancelClicked() {
    this.isDatePickerVisible = false;
    this.isDurationVisible = false;
  }

  onApplyClicked() {
    this.change.emit(this.selectedValuetobeEmited);
    this.toggleValue[0].label = this.selectedValue;
    this.isDatePickerVisible = false;
    this.isDurationVisible = false;
    this.isDurationVisible = false;

  }

  setSelectedValue(value: string) {
    this.selectedValue = value;
  }
}
